
import { Component, Vue, Watch } from "vue-property-decorator";
import ExamList from "@/lib/model/exam/exam";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import CandidateCreateForm from "@/lib/form/candidate/CandidateCreateForm";
import ModalTitle from "@/lib/model/exam/modal-title";
import ExamListForm, { UploadParamsForm } from "@/lib/form/exam/ExamListForm";
import { StructParam } from "@/lib/form/candidate/CandidateCreateForm";
import Candidate, { CandidateMCreateParams } from "@/lib/model/exam/candidate";
import { CandidateListExportParams } from "@/lib/model/exam/candidate";
import _ from "lodash-es";
import { CandidateMCreateParseParams } from "../../lib/model/exam/candidate";
import CandidateExportForm from "@/lib/form/candidate/CandidateExportForm";
import dayjs from "dayjs";

import {
  ExamCopyForm,
  ExamDeleteForm,
  ExamGetForm
} from "@/lib/form/exam/ExamListForm";
import Config from "@/config/config";
import TimeUtil from "@/lib/common/time-util";

export class Search {
  status = 0;
  name = "";
  remark = "";
}

@Component({})
export default class SfExport extends Vue {
  name = "sf-export";
  listForm: ExamListForm = new ExamListForm();
  list: ExamList[] = new Array<ExamList>();
  showWord = true;
  search: Search = new Search();
  total = 0;
  loading = false;
  tableLoading = true;
  address = "";
  addressImage = "data:image/png;base64,";
  hasLoad = false;
  page = 1;
  settingForm = {};
  isShowAddOne = false;
  isShowAddMore = false;
  candidateCreateForm = new CandidateCreateForm();
  candidateExportForm = new CandidateExportForm();
  link = "";
  scanLink = "";
  scanUrl = "";
  modalTitle: ModalTitle = new ModalTitle();
  examGetForm: ExamGetForm = new ExamGetForm();
  structParams: StructParam[] = new Array<StructParam>();
  showExamUrl = false;
  candidateExportParams = new CandidateListExportParams();
  isShowCopyModal = false;
  isShowDelModal = false;
  examCopyForm = new ExamCopyForm();
  examDeleteForm = new ExamDeleteForm();
  uploadParams = new UploadParamsForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  currentPageSize = 10;
  vuexStores = vuexStore;
  examList: ExamList = new ExamList();
  examName = "";
  currentCompanyId = 0;
  isShowExportAll = false;

  created() {
    this.currentCompanyId = parseInt(Auth.companyId);
    const nowToken = Auth.token;
    if (this.currentCompanyId !== 80925 || !nowToken) {
      this.$router
        .push("/exam/paper?companyId=" + this.currentCompanyId)
        .catch(err => err);
    }
  }

  exportAll() {
    if (
      this.candidateExportForm.submitTimeStart == "" &&
      this.candidateExportForm.submitTimeStop == ""
    ) {
      this.$message.error("请选择面试时间");
      return;
    } else if (this.candidateExportForm.submitTimeStart == "") {
      this.$message.error("请选择面试开始时间");
      return;
    } else if (this.candidateExportForm.submitTimeStop == "") {
      this.$message.error("请选择面试结束时间");
      return;
    } else {
      this.candidateExportForm.submitTimeStart = dayjs(
        this.candidateExportForm.submitTimeStart
      ).format("YYYY-MM-DD HH:mm:ss");
      this.candidateExportForm.submitTimeStop = dayjs(
        this.candidateExportForm.submitTimeStop
      ).format("YYYY-MM-DD HH:mm:ss");
      if (
        this.candidateExportForm.submitTimeStart >
        this.candidateExportForm.submitTimeStop
      ) {
        this.$message.error("面试时间选择有误");
        return false;
      }
    }

    this.candidateExportForm.companyId = parseInt(Auth.companyId);
    // this.$message.error("导出失败");
    // return;
    this.candidateExportForm.async = 1;
    Candidate.candidateAnswerAllExport(this.candidateExportForm)
      .then(res => {
        if (res.code === 0) {
          // const dataUrl = res.data.ossUrl;
          // const a = document.createElement("a");
          // a.href = dataUrl;
          // a.setAttribute("download", "候选人答题详情列表");
          // a.click();
          this.$message.success(
            "导出任务发起成功，请在导出列表页查看导出状态。"
          );
        } else {
          this.$message.error("导出失败");
        }
      })
      .finally(() => {
        this.isShowExportAll = false;
      });
  }

  candidateAll() {
    if (
      this.candidateExportForm.submitTimeStart == "" &&
      this.candidateExportForm.submitTimeStop == ""
    ) {
      this.$message.error("请选择面试时间");
      return;
    } else if (this.candidateExportForm.submitTimeStart == "") {
      this.$message.error("请选择面试开始时间");
      return;
    } else if (this.candidateExportForm.submitTimeStop == "") {
      this.$message.error("请选择面试结束时间");
      return;
    } else {
      this.candidateExportForm.submitTimeStart = dayjs(
        this.candidateExportForm.submitTimeStart
      ).format("YYYY-MM-DD HH:mm:ss");
      this.candidateExportForm.submitTimeStop = dayjs(
        this.candidateExportForm.submitTimeStop
      ).format("YYYY-MM-DD HH:mm:ss");
      if (
        this.candidateExportForm.submitTimeStart >
        this.candidateExportForm.submitTimeStop
      ) {
        this.$message.error("面试时间选择有误");
        return false;
      }
    }

    this.candidateExportForm.companyId = parseInt(Auth.companyId);
    this.candidateExportForm.async = 1;
    // this.$message.error("导出失败");
    // return;
    Candidate.candidateAllExport(this.candidateExportForm)
      .then((res: any) => {
        if (res.code === 0) {
          if (res.data.isAsync === 1) {
            const exportListUrl = `/export/list?companyId=${Auth.companyId}`;
            window.open(exportListUrl);
            this.$message.success(
              "导出任务创建成功，可点击左侧菜单【导出任务列表】查看进度"
            );
          } else {
            const dataUrl = res.data.ossUrl;
            const a = document.createElement("a");
            a.href = dataUrl;
            a.setAttribute("download", "候选人答题详情列表");
            a.click();
          }
        } else {
          this.$message.error("导出失败");
        }
      })
      .finally(() => {
        this.isShowExportAll = false;
      });
  }

  addCancel() {
    this.isShowAddOne = false;
    this.getList();
  }

  addSubmit() {
    this.getList();
    this.isShowAddOne = false;
  }

  handleUrlClose() {
    this.showExamUrl = false;
  }

  addSubmitContinue() {
    this.isShowAddOne = false;
  }

  addMoreCancel() {
    this.isShowAddMore = false;
  }

  addMoreSubmit() {
    this.isShowAddMore = false;
  }

  handleMoreClose() {
    this.getList();
    this.isShowAddOne = false;
    this.isShowAddMore = false;
  }

  handleOneClose() {
    this.getList();
    this.isShowAddMore = false;
    this.isShowAddOne = false;
  }

  getList(param = "") {
    this.currentCompanyId = parseInt(Auth.companyId);
    console.log("currentCompanyId: ", this.currentCompanyId);
    this.tableLoading = true;
    const getListForm = new ExamListForm();
    // getListForm.userId = parseInt(Auth.userId);
    if (param === "pageSize" || param == "search-name") {
      getListForm.page = 1;
    } else {
      getListForm.page = this.listForm.page;
    }
    getListForm.nameOrRemark = this.search.name;
    getListForm.pageSize = this.currentPageSize;
    Auth.currentPageSize = String(this.currentPageSize);
    getListForm.companyId = parseInt(Auth.companyId);
    switch (this.search.status) {
      case 1:
        getListForm.beforeStart = 1;
        break;
      case 2:
        getListForm.isPlaying = 1;
        break;
      case 3:
        getListForm.afterEnd = 1;
        break;
    }
    ExamList.getList(getListForm)
      .then(res => {
        this.total = res.count;
        this.list = res.exams;
      })
      .finally(() => {
        this.tableLoading = false;
      });
  }

  className(status: number) {
    switch (status) {
      case 1:
        return "green";
      case 2:
        return "blue";
      case 3:
        return "gray";
    }
  }

  // copyLink() {
  //   return;
  // }

  downLoadBarcode() {
    const a = document.createElement("a");
    a.href = this.addressImage;
    a.setAttribute("download", "在线面试二维码");
    a.click();
  }
}
